<template>
  <!-- 排行榜 -->
  <div class="rank-wrapper" :class="!isPC ? 'm-rank-wrapper' : ''">
    <p class="rank-title" :class="popInKr ? 'in-kr-color' : ''">{{ currentLang === 'en' ? 'Ranking list' : '排行榜' }}</p>
    <div class="sub-wrapper">
      <ul class="nav nav-tabs" :class="popInKr ? 'in-kr-color' : ''">
        <li v-for="item of rankMenus" :key="item.key" class="nav-item"
          :class="activityItem === item.key ? 'active' : ''" @click="selectItem(item.key)">
          <span class="nav-link">{{ currentLang === 'en' ? item.nameEn
            : item.name
            }}</span>
        </li>
      </ul>
      <div class="rank-list">
        <ul class="list-group list-group-flush" :class="popInKr ? 'in-kr-color' : ''">
          <li class="list-group-item group-title">
            <span class="rank-num">{{ currentLang === 'en' ? 'Rank' : '排名' }}</span>
            <span v-if="activityItem === 'youth_science' || activityItem === 'exam'" class="rank-name">{{ currentLang
              ===
              'en' ? 'Name of Work' : '作品名称'
              }}</span>
            <span v-else class="rank-name">{{ currentLang === 'en' ? 'Exhibitors' : '单位名称' }}</span>
            <span class="rank-total-num">{{ currentLang === 'en' ? 'Rocket Speed' : '火箭速度' }}</span>
          </li>
          <li v-for="(item, index) of rankData[activityItem]" :key="item.boothNo" class="list-group-item">
            <span class="rank-num rank-num-item">{{ index + 1 }}</span>
            <span class="rank-name">{{ item.worksName || item.companyName }}</span>
            <span class="rank-total-num">{{ item._likeNum }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Rank',
  props: ['popInKr'],
  data() {
    return {
      activityItem: 'youth_science',
      rankMenus: [
        {
          name: '创新成果',
          nameEn: 'Innovation Works',
          key: 'youth_science'
        },
        // {
        //   name: '明日之星',
        //   nameEn: 'Outstanding Works',
        //   key: 'star'
        // },
        {
          name: '区教育局',
          nameEn: 'District Education Bureau',
          key: 'edu'
        },
        {
          name: '工作站',
          nameEn: 'Practice Workstation ',
          key: 'station'
        },
        {
          name: '科创教育基地',
          nameEn: 'Science and Innovation Education Base',
          key: 'exam'
        },
        {
          name: '企业机构',
          nameEn: 'Enterprises and Demonstration Exhibition Hall',
          key: 'company'
        }
      ],
      rankData: {
        youth_science: [],// A区
        exam: [],// E区
        edu: [], // B区
        station: [],// C区
        company: [], // F区 企业展
        star: [] //D区 明日之星
      }
    }
  },
  mounted() {
    axios.get('https://thumbsup-qbh-java-igdpvltehu.cn-shanghai.fcapp.run/show/refreshPraiseNew').then((response) => {
      if (response.data.status === 'success') {
        //  totalLike = response.data.data;
        //  console.log(totalLike,123)
        this.$setItem('_totalLike', response.data.data);
        this.initRank()
      }
      // cl.doCmdA()
    })

  },
  methods: {
    initRank() {


      let data = this.$allData[this.currentLang] || []
      let totalLike = this.$getItem('_totalLike') || this.$allData.totalLike || {};
      console.log(totalLike, this.$getItem('_totalLike'));
      let youth_science = [] // A区
      let exam = []// E区
      let edu = [] // B区
      let station = []// C区
      let company = [] // F区 企业展
      let star = [] //D区 明日之星
      for (let item of data) {
        item._likeNum = totalLike[item.uuid] || 0
        if (item.boothNo && item.boothNo.indexOf('A') >= 0) {
          youth_science.push(item)
        } else if (item.boothNo && item.boothNo.indexOf('E') >= 0) {
          exam.push(item)
        } else if (item.boothNo && item.boothNo.indexOf('B') >= 0) {
          edu.push(item)
        } else if (item.boothNo && item.boothNo.indexOf('C') >= 0) {
          station.push(item)
        } else if (item.boothNo && item.boothNo.indexOf('D') >= 0) {
          star.push(item)
        } else if (item.boothNo && item.boothNo.indexOf('F') >= 0) {
          company.push(item)
        }
      }
      this.rankData = {
        star: this.doRank(star),
        youth_science: this.doRank(youth_science),
        exam: this.doRank(exam),
        edu: this.doRank(edu),
        station: this.doRank(station),
        company: this.doRank(company)
      }
    },
    doRank(arrData) {
      let newArr = arrData.sort((pre, next) => next._likeNum - pre._likeNum)
      newArr = newArr.slice(0, 10)
      return newArr
    },
    selectItem(key) {
      if (this.activityItem !== key) {
        this.activityItem = key
      }
    }
  }
}
</script>

<style scoped>
.rank-wrapper {
  width: 100%;
  height: 100%;
  margin-bottom: 50px;
}

.rank-title {
  padding-top: 6rem;
  text-align: center;
  font-size: 14px;
  font-weight: 550;
}

.sub-wrapper {
  width: 120rem;
  margin: 0 auto;
}


.nav {
  justify-content: center;
}

.nav-tabs {
  background-color: #ec6000;
  border: none;
}

.nav-item {
  cursor: pointer;
  width: 16.66%;
  text-align: center;
  margin-bottom: 0px;
}

.nav-item .nav-link {
  border-radius: 0px;
  border: none;
}

.active {
  color: #ffffff;
  background-color: #ff942c;
  border-color: #ff942c;
}

.in-kr-color {
  color: #ffffff;
}

.rank-list {
  padding-left: 20px;
  padding-right: 20px;
}

.list-group-item {
  background: none;
}

.group-title {
  border-bottom: 1px solid #ff942c;
}

.rank-num {
  width: 10%;
  display: inline-block;
}

.rank-num-item {
  font-size: 24px;
  font-weight: 550;
}

.rank-name {
  width: 80%;
  display: inline-block;
}

.rank-total-num {
  width: 9%;
  display: inline-block;
}

.m-rank-wrapper .sub-wrapper {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 50px;
}

.m-rank-wrapper .nav-item {
  width: 16.66%;
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-all;
}

.m-rank-wrapper .nav-item span {
  font-size: 12px;
}

.m-rank-wrapper .rank-num {
  width: 15%;
  font-size: 14px;
}

.m-rank-wrapper .rank-name {
  width: 65%;
  font-size: 14px;
}

.m-rank-wrapper .rank-total-num {
  width: 20%;
  font-size: 14px;
  text-align: center;
}
</style>
